/* WSP support pipeline runs FIRST: a runtime error in any later
   module can no longer prevent form interception. */
/* ==========================================================================
   Custom contact pipeline (v4.43) - forms marked with [data-wsp-form]
   submit to the WSP Support Apps Script backend: branded owner email with
   inline photo thumbnails, customer confirmation with ticket number, and
   a Google Sheet inbox. If the backend is missing or unreachable, the
   form falls back to Shopify's native contact submission - no message
   can ever be lost.
   ========================================================================== */
/* i18n for JS-generated text: same mechanism as the finder. English is
   the source; add a locale block to extend. */
var GJS_I18N = {
  sv: {
    'Import fees are already included in the price shown below.': 'Importavgifter ingår redan i priset som visas nedan.',
    'Final price depends on total order weight, shown at checkout.': 'Slutpriset beror på beställningens totala vikt och visas i kassan.',
    'Enter a valid email address.': 'Ange en giltig e-postadress.',
    'Saving…': 'Sparar…',
    'Done. We\'ll email {e} the moment it\'s back.': 'Klart. Vi mejlar {e} så fort den är tillbaka.',
    'Could not save that. Please try again in a moment.': 'Det gick inte att spara. Försök igen om en stund.',
    'on {d}': 'på {d}',
    'hours': 'timmar',
    'Express shipping': 'Expressfrakt',
    'UPS Economy': 'UPS Economy',
    'We could not confirm your message was sent.': 'Vi kunde inte bekräfta att ditt meddelande skickades.',
    'Your text is safe in the form. Please try again, or send it by email with one click:': 'Din text är kvar i formuläret. Försök igen, eller skicka det via e-post med ett klick:',
    'Try again': 'Försök igen',
    'Message sent': 'Meddelande skickat',
    'A confirmation was sent to <strong>{e}</strong>.': 'En bekräftelse skickades till <strong>{e}</strong>.',
    'Could not add to cart': 'Kunde inte lägga till i varukorgen',
    'Added': 'Tillagd',
    'Out of stock': 'Slut i lager',
    'In stock': 'I lager',
    'Add to cart': 'Lägg i varukorgen',
    'Shipped from Portugal. Enter your zip code so we can check regional exceptions.': 'Skickas från Portugal. Ange ditt postnummer så att vi kan kontrollera regionala undantag.',
    'Shipped from Portugal. Select your destination to see estimated shipping options.': 'Skickas från Portugal. Välj din destination för att se beräknade fraktalternativ.',
    'Sorry, we do not ship to French Overseas Territories.': 'Tyvärr, vi skickar inte till franska utomeuropeiska territorier.',
    'Photos attached. They will be included with your message.': 'Foton bifogade. De skickas med ditt meddelande.',
    'Photo attached. It will be included with your message.': 'Foto bifogat. Det skickas med ditt meddelande.',
    'Only image files can be attached.': 'Endast bildfiler kan bifogas.',
    'Uploading photo…': 'Laddar upp foto…',
    'That photo is too large. Please try one under 8MB.': 'Fotot är för stort. Prova ett under 8 MB.',
    'That photo could not be uploaded. You can still send the message and email photos afterwards.': 'Fotot kunde inte laddas upp. Du kan ändå skicka meddelandet och mejla foton efteråt.',
    'One moment, your photo is still uploading…': 'Ett ögonblick, ditt foto laddas fortfarande upp…',
    'Added ✓': 'Tillagd ✓',
    'Added to cart': 'Tillagd i varukorgen',
    'Adding…': 'Lägger till…',
    'Available Service': 'Tillgänglig tjänst',
    'Cost': 'Kostnad',
    'Please enter a Zip code for this destination.': 'Ange ett postnummer för denna destination.',
    'Please select a destination country.': 'Välj ett destinationsland.',
    'Send by email instead': 'Skicka via e-post istället',
    'Sending…': 'Skickar…',
    'Ticket': 'Ärende',
    'Use the basic form': 'Använd det enkla formuläret',
    'We will confirm the belt match. The belt is free, you only pay shipping.': 'Vi bekräftar remmatchningen. Remmen är gratis, du betalar bara frakten.',
    'We reply Monday to Friday, and order issues get priority.': 'Vi svarar måndag till fredag, och orderärenden får förtur.',
    'We reply Monday to Friday, 09:00–17:00 Central European Time.': 'Vi svarar måndag till fredag, 09:00–17:00 centraleuropeisk tid.',
    'Sunday': 'söndag',
    'Monday': 'måndag',
    'Tuesday': 'tisdag',
    'Wednesday': 'onsdag',
    'Thursday': 'torsdag',
    'Friday': 'fredag',
    'Saturday': 'lördag',
    'Please enter a valid Zip code for': 'Ange ett giltigt postnummer för',
    'No shipping rate is currently available for this destination at checkout. Please contact us before ordering.': 'Ingen fraktkostnad finns för närvarande tillgänglig för denna destination i kassan. Kontakta oss innan du beställer.',
    'Rates shown are the most common small-parts options. Belts, rollers and similar light items usually qualify for the lowest available rate.': 'Priserna som visas är de vanligaste alternativen för smådelar. Remmar, tryckhjul och liknande lätta artiklar kvalificerar sig oftast för det lägsta tillgängliga priset.',
    'Import fees are included in both United States shipping options shown below.': 'Importavgifter ingår i båda fraktalternativen till USA som visas nedan.',
    'Local currency values are indicative. Small differences may appear at checkout due to exchange-rate movement, rounding, or bank fees.': 'Värden i lokal valuta är vägledande. Små skillnader kan uppstå i kassan på grund av valutakursrörelser, avrundning eller bankavgifter.',
    'Order within': 'Beställ inom',
    'Estimated:': 'Beräknat:',
    'working day': 'arbetsdag',
    'working days': 'arbetsdagar',
    'Last unit left': 'Sista enheten kvar',
    'Unavailable': 'Ej tillgänglig',
    'tomorrow': 'imorgon',
    'Economic Shipping (Small Parts)': 'Ekonomifrakt (smådelar)',
    'Tracked Shipping': 'Spårad frakt',
    'CTT Expresso': 'CTT Expresso',
    'Registered Mail': 'Rekommenderat brev',
    'Economic Shipping': 'Ekonomifrakt',
    'Economy Shipping (Small Parts)': 'Ekonomifrakt (smådelar)',
    'Small Value ECO Shipping': 'ECO-frakt för lågt värde',
    'Tracked Postage': 'Spårad postgång',
    'MRW Urgente 24/48 Horas': 'MRW Urgente 24/48 timmar',
    'MRW Urgente 24/48 Horas (Large Order)': 'MRW Urgente 24/48 timmar (stor beställning)',
    'and it ships': 'och den skickas',
    'today': 'idag',
    'Order now, ships': 'Beställ nu, skickas',
    '(next working day).': '(nästa arbetsdag).'
  },
  de: {
    'Import fees are already included in the price shown below.': 'Einfuhrgebühren sind im unten gezeigten Preis bereits enthalten.',
    'Final price depends on total order weight, shown at checkout.': 'Der Endpreis hängt vom Gesamtgewicht der Bestellung ab und wird an der Kasse angezeigt.',
    'Enter a valid email address.': 'Geben Sie eine gültige E-Mail-Adresse ein.',
    'Saving…': 'Wird gespeichert…',
    'Done. We\'ll email {e} the moment it\'s back.': 'Erledigt. Wir schreiben an {e}, sobald es wieder da ist.',
    'Could not save that. Please try again in a moment.': 'Das konnte nicht gespeichert werden. Bitte versuchen Sie es gleich erneut.',
    'Out of stock': 'Nicht auf Lager',
    'In stock': 'Auf Lager',
    'Add to cart': 'In den Warenkorb',
    'Shipped from Portugal. Select your destination to see estimated shipping options.': 'Versand aus Portugal. Wählen Sie Ihr Zielland, um die voraussichtlichen Versandoptionen zu sehen.',
    'Last unit left': 'Letztes Stück',
    'on {d}': 'am {d}',
    'hours': 'Stunden',
    'Express shipping': 'Expressversand',
    'UPS Economy': 'UPS Economy',
    'We could not confirm your message was sent.': 'Wir konnten nicht bestätigen, dass Ihre Nachricht gesendet wurde.',
    'Your text is safe in the form. Please try again, or send it by email with one click:': 'Ihr Text ist im Formular gesichert. Bitte versuchen Sie es erneut oder senden Sie ihn mit einem Klick per E-Mail:',
    'Try again': 'Erneut versuchen',
    'Message sent': 'Nachricht gesendet',
    'A confirmation was sent to <strong>{e}</strong>.': 'Eine Bestätigung wurde an <strong>{e}</strong> gesendet.',
    'Could not add to cart': 'Konnte nicht in den Warenkorb gelegt werden',
    'Added': 'Hinzugefügt',
    'Shipped from Portugal. Enter your zip code so we can check regional exceptions.': 'Versand aus Portugal. Geben Sie Ihre Postleitzahl ein, damit wir regionale Ausnahmen prüfen können.',
    'Sorry, we do not ship to French Overseas Territories.': 'Leider versenden wir nicht in die französischen Überseegebiete.',
    'Photos attached. They will be included with your message.': 'Fotos angehängt. Sie werden Ihrer Nachricht beigefügt.',
    'Photo attached. It will be included with your message.': 'Foto angehängt. Es wird Ihrer Nachricht beigefügt.',
    'Only image files can be attached.': 'Es können nur Bilddateien angehängt werden.',
    'Uploading photo…': 'Foto wird hochgeladen…',
    'That photo is too large. Please try one under 8MB.': 'Dieses Foto ist zu groß. Bitte versuchen Sie eines unter 8 MB.',
    'That photo could not be uploaded. You can still send the message and email photos afterwards.': 'Dieses Foto konnte nicht hochgeladen werden. Sie können die Nachricht trotzdem senden und die Fotos anschließend per E-Mail schicken.',
    'One moment, your photo is still uploading…': 'Einen Moment, Ihr Foto wird noch hochgeladen…',
    'Added ✓': 'Hinzugefügt ✓',
    'Added to cart': 'In den Warenkorb gelegt',
    'Adding…': 'Wird hinzugefügt…',
    'Available Service': 'Verfügbarer Service',
    'Cost': 'Kosten',
    'Please enter a Zip code for this destination.': 'Bitte geben Sie eine Postleitzahl für dieses Zielland ein.',
    'Please select a destination country.': 'Bitte wählen Sie ein Zielland.',
    'Send by email instead': 'Stattdessen per E-Mail senden',
    'Sending…': 'Wird gesendet…',
    'Ticket': 'Ticket',
    'Unavailable': 'Nicht verfügbar',
    'Use the basic form': 'Das einfache Formular verwenden',
    'We will confirm the belt match. The belt is free, you only pay shipping.': 'Wir bestätigen die Riemenübereinstimmung. Der Riemen ist kostenlos, Sie zahlen nur den Versand.',
    'We reply Monday to Friday, and order issues get priority.': 'Wir antworten Montag bis Freitag, und Bestellanliegen haben Vorrang.',
    'We reply Monday to Friday, 09:00–17:00 Central European Time.': 'Wir antworten Montag bis Freitag, 09:00–17:00 Uhr mitteleuropäischer Zeit.',
    'tomorrow': 'morgen',
    'Sunday': 'Sonntag',
    'Monday': 'Montag',
    'Tuesday': 'Dienstag',
    'Wednesday': 'Mittwoch',
    'Thursday': 'Donnerstag',
    'Friday': 'Freitag',
    'Saturday': 'Samstag',
    'Economic Shipping (Small Parts)': 'Economy-Versand (Kleinteile)',
    'Tracked Shipping': 'Versand mit Sendungsverfolgung',
    'CTT Expresso': 'CTT Expresso',
    'Registered Mail': 'Einschreiben',
    'Economic Shipping': 'Economy-Versand',
    'Economy Shipping (Small Parts)': 'Economy-Versand (Kleinteile)',
    'Small Value ECO Shipping': 'ECO-Versand für Kleinwerte',
    'Tracked Postage': 'Briefversand mit Sendungsverfolgung',
    'MRW Urgente 24/48 Horas': 'MRW Urgente 24/48 Stunden',
    'MRW Urgente 24/48 Horas (Large Order)': 'MRW Urgente 24/48 Stunden (Großbestellung)',
    'Please enter a valid Zip code for': 'Bitte geben Sie eine gültige Postleitzahl ein für',
    'No shipping rate is currently available for this destination at checkout. Please contact us before ordering.': 'Für dieses Zielland ist an der Kasse derzeit kein Versandtarif verfügbar. Bitte kontaktieren Sie uns vor der Bestellung.',
    'Rates shown are the most common small-parts options. Belts, rollers and similar light items usually qualify for the lowest available rate.': 'Die angezeigten Tarife sind die gängigsten Optionen für Kleinteile. Riemen, Rollen und ähnliche leichte Artikel qualifizieren sich in der Regel für den günstigsten verfügbaren Tarif.',
    'Import fees are included in both United States shipping options shown below.': 'Einfuhrgebühren sind in beiden unten gezeigten Versandoptionen für die USA enthalten.',
    'Local currency values are indicative. Small differences may appear at checkout due to exchange-rate movement, rounding, or bank fees.': 'Werte in Landeswährung sind Richtwerte. An der Kasse können kleine Abweichungen durch Wechselkursbewegungen, Rundung oder Bankgebühren auftreten.',
    'Order within': 'Bestellen Sie innerhalb von',
    'and it ships': 'und der Versand erfolgt',
    'today': 'heute',
    'Order now, ships': 'Jetzt bestellen, Versand',
    '(next working day).': '(nächster Werktag).',
    'Estimated:': 'Voraussichtlich:',
    'working day': 'Werktag',
    'working days': 'Werktage',
  },
  it: {
    'Import fees are already included in the price shown below.': 'Le tasse di importazione sono già incluse nel prezzo mostrato qui sotto.',
    'Final price depends on total order weight, shown at checkout.': 'Il prezzo finale dipende dal peso totale dell’ordine, mostrato al checkout.',
    'Enter a valid email address.': 'Inserisci un indirizzo email valido.',
    'Saving…': 'Salvataggio…',
    'Done. We\'ll email {e} the moment it\'s back.': 'Fatto. Scriviamo a {e} appena torna disponibile.',
    'Could not save that. Please try again in a moment.': 'Impossibile salvare. Riprova tra un istante.',
    'Out of stock': 'Esaurito',
    'In stock': 'Disponibile',
    'Add to cart': 'Aggiungi al carrello',
    'Shipped from Portugal. Select your destination to see estimated shipping options.': 'Spedito dal Portogallo. Seleziona la tua destinazione per vedere le opzioni di spedizione stimate.',
    'Last unit left': 'Ultimo pezzo rimasto',
    'on {d}': '{d}',
    'hours': 'ore',
    'Express shipping': 'Spedizione espressa',
    'UPS Economy': 'UPS Economy',
    'We could not confirm your message was sent.': 'Non abbiamo potuto confermare l\'invio del tuo messaggio.',
    'Your text is safe in the form. Please try again, or send it by email with one click:': 'Il tuo testo è al sicuro nel modulo. Riprova, oppure invialo per email con un clic:',
    'Try again': 'Riprova',
    'Message sent': 'Messaggio inviato',
    'A confirmation was sent to <strong>{e}</strong>.': 'Una conferma è stata inviata a <strong>{e}</strong>.',
    'Could not add to cart': 'Impossibile aggiungere al carrello',
    'Added': 'Aggiunto',
    'Shipped from Portugal. Enter your zip code so we can check regional exceptions.': 'Spedito dal Portogallo. Inserisci il CAP così possiamo verificare le eccezioni regionali.',
    'Sorry, we do not ship to French Overseas Territories.': 'Ci dispiace, non spediamo nei Territori Francesi d\'Oltremare.',
    'Photos attached. They will be included with your message.': 'Foto allegate. Saranno incluse nel tuo messaggio.',
    'Photo attached. It will be included with your message.': 'Foto allegata. Sarà inclusa nel tuo messaggio.',
    'Only image files can be attached.': 'È possibile allegare solo file immagine.',
    'Uploading photo…': 'Caricamento della foto…',
    'That photo is too large. Please try one under 8MB.': 'Quella foto è troppo grande. Provane una sotto gli 8 MB.',
    'That photo could not be uploaded. You can still send the message and email photos afterwards.': 'Non è stato possibile caricare quella foto. Puoi comunque inviare il messaggio e mandare le foto per email dopo.',
    'One moment, your photo is still uploading…': 'Un momento, la tua foto è ancora in caricamento…',
    'Added ✓': 'Aggiunto ✓',
    'Added to cart': 'Aggiunto al carrello',
    'Adding…': 'Aggiunta in corso…',
    'Available Service': 'Servizio disponibile',
    'Cost': 'Costo',
    'Please enter a Zip code for this destination.': 'Inserisci un CAP per questa destinazione.',
    'Please select a destination country.': 'Seleziona un paese di destinazione.',
    'Send by email instead': 'Invia invece per email',
    'Sending…': 'Invio in corso…',
    'Ticket': 'Ticket',
    'Unavailable': 'Non disponibile',
    'Use the basic form': 'Usa il modulo semplice',
    'We will confirm the belt match. The belt is free, you only pay shipping.': 'Confermeremo l\'abbinamento della cinghia. La cinghia è gratuita, paghi solo la spedizione.',
    'We reply Monday to Friday, and order issues get priority.': 'Rispondiamo dal lunedì al venerdì, e i problemi sugli ordini hanno priorità.',
    'We reply Monday to Friday, 09:00–17:00 Central European Time.': 'Rispondiamo dal lunedì al venerdì, 09:00–17:00 ora dell\'Europa centrale.',
    'tomorrow': 'domani',
    'Sunday': 'domenica',
    'Monday': 'lunedì',
    'Tuesday': 'martedì',
    'Wednesday': 'mercoledì',
    'Thursday': 'giovedì',
    'Friday': 'venerdì',
    'Saturday': 'sabato',
    'Economic Shipping (Small Parts)': 'Spedizione economica (ricambi piccoli)',
    'Tracked Shipping': 'Spedizione tracciata',
    'CTT Expresso': 'CTT Expresso',
    'Registered Mail': 'Posta raccomandata',
    'Economic Shipping': 'Spedizione economica',
    'Economy Shipping (Small Parts)': 'Spedizione economy (ricambi piccoli)',
    'Small Value ECO Shipping': 'Spedizione ECO basso valore',
    'Tracked Postage': 'Posta tracciata',
    'MRW Urgente 24/48 Horas': 'MRW Urgente 24/48 Horas',
    'MRW Urgente 24/48 Horas (Large Order)': 'MRW Urgente 24/48 Horas (ordine grande)',
    'Please enter a valid Zip code for': 'Inserisci un CAP valido per',
    'No shipping rate is currently available for this destination at checkout. Please contact us before ordering.': 'Al momento nessuna tariffa di spedizione è disponibile per questa destinazione al checkout. Contattaci prima di ordinare.',
    'Rates shown are the most common small-parts options. Belts, rollers and similar light items usually qualify for the lowest available rate.': 'Le tariffe mostrate sono le opzioni più comuni per ricambi piccoli. Cinghie, rulli e articoli leggeri simili di solito rientrano nella tariffa più bassa disponibile.',
    'Import fees are included in both United States shipping options shown below.': 'Le tasse di importazione sono incluse in entrambe le opzioni di spedizione per gli Stati Uniti mostrate qui sotto.',
    'Local currency values are indicative. Small differences may appear at checkout due to exchange-rate movement, rounding, or bank fees.': 'I valori in valuta locale sono indicativi. Al checkout possono comparire piccole differenze dovute a variazioni del cambio, arrotondamenti o commissioni bancarie.',
    'Order within': 'Ordina entro',
    'and it ships': 'e parte',
    'today': 'oggi',
    'Order now, ships': 'Ordina ora, parte',
    '(next working day).': '(il prossimo giorno lavorativo).',
    'Estimated:': 'Stimato:',
    'working day': 'giorno lavorativo',
    'working days': 'giorni lavorativi'
  },
  fr: {
    'Import fees are already included in the price shown below.': 'Les frais d\'importation sont déjà inclus dans le prix affiché ci-dessous.',
    'Final price depends on total order weight, shown at checkout.': 'Le prix final dépend du poids total de la commande, affiché au paiement.',
    'Enter a valid email address.': 'Saisissez une adresse e-mail valide.',
    'Saving…': 'Enregistrement…',
    'Done. We\'ll email {e} the moment it\'s back.': 'C\'est fait. Nous écrirons à {e} dès son retour en stock.',
    'Could not save that. Please try again in a moment.': 'Impossible d\'enregistrer. Veuillez réessayer dans un instant.',
    'Out of stock': 'Rupture de stock',
    'In stock': 'En stock',
    'Add to cart': 'Ajouter au panier',
    'Shipped from Portugal. Select your destination to see estimated shipping options.': 'Expédié depuis le Portugal. Sélectionnez votre destination pour voir les options d\'expédition estimées.',
    'Last unit left': 'Dernière unité disponible',
    'on {d}': 'le {d}',
    'hours': 'heures',
    'Express shipping': 'Expédition express',
    'UPS Economy': 'UPS Economy',
    'We could not confirm your message was sent.': 'Nous n\'avons pas pu confirmer l\'envoi de votre message.',
    'Your text is safe in the form. Please try again, or send it by email with one click:': 'Votre texte est conservé dans le formulaire. Réessayez, ou envoyez-le par e-mail en un clic :',
    'Try again': 'Réessayer',
    'Message sent': 'Message envoyé',
    'A confirmation was sent to <strong>{e}</strong>.': 'Une confirmation a été envoyée à <strong>{e}</strong>.',
    'Could not add to cart': 'Impossible d\'ajouter au panier',
    'Added': 'Ajouté',
    'Shipped from Portugal. Enter your zip code so we can check regional exceptions.': 'Expédié depuis le Portugal. Saisissez votre code postal pour que nous vérifiions les exceptions régionales.',
    'Sorry, we do not ship to French Overseas Territories.': 'Désolé, nous ne livrons pas les territoires français d\'outre-mer.',
    'Photos attached. They will be included with your message.': 'Photos jointes. Elles seront incluses avec votre message.',
    'Photo attached. It will be included with your message.': 'Photo jointe. Elle sera incluse avec votre message.',
    'Only image files can be attached.': 'Seuls les fichiers image peuvent être joints.',
    'Uploading photo…': 'Envoi de la photo…',
    'That photo is too large. Please try one under 8MB.': 'Cette photo est trop volumineuse. Essayez-en une de moins de 8 Mo.',
    'That photo could not be uploaded. You can still send the message and email photos afterwards.': 'Cette photo n\'a pas pu être envoyée. Vous pouvez quand même envoyer le message et envoyer les photos par e-mail ensuite.',
    'One moment, your photo is still uploading…': 'Un instant, votre photo est encore en cours d\'envoi…',
    'Added ✓': 'Ajouté ✓',
    'Added to cart': 'Ajouté au panier',
    'Adding…': 'Ajout…',
    'Available Service': 'Service disponible',
    'Cost': 'Coût',
    'Please enter a Zip code for this destination.': 'Veuillez saisir un code postal pour cette destination.',
    'Please select a destination country.': 'Veuillez sélectionner un pays de destination.',
    'Send by email instead': 'Envoyer par e-mail à la place',
    'Sending…': 'Envoi…',
    'Ticket': 'Ticket',
    'Unavailable': 'Indisponible',
    'Use the basic form': 'Utiliser le formulaire simple',
    'We will confirm the belt match. The belt is free, you only pay shipping.': 'Nous confirmerons la correspondance de la courroie. La courroie est gratuite, vous ne payez que l\'expédition.',
    'We reply Monday to Friday, and order issues get priority.': 'Nous répondons du lundi au vendredi, et les problèmes de commande sont prioritaires.',
    'We reply Monday to Friday, 09:00–17:00 Central European Time.': 'Nous répondons du lundi au vendredi, de 9h00 à 17h00, heure d\'Europe centrale.',
    'tomorrow': 'demain',
    'Sunday': 'dimanche',
    'Monday': 'lundi',
    'Tuesday': 'mardi',
    'Wednesday': 'mercredi',
    'Thursday': 'jeudi',
    'Friday': 'vendredi',
    'Saturday': 'samedi',
    'Economic Shipping (Small Parts)': 'Expédition économique (petites pièces)',
    'Tracked Shipping': 'Expédition suivie',
    'CTT Expresso': 'CTT Expresso',
    'Registered Mail': 'Courrier recommandé',
    'Economic Shipping': 'Expédition économique',
    'Economy Shipping (Small Parts)': 'Expédition économique (petites pièces)',
    'Small Value ECO Shipping': 'Expédition ECO petite valeur',
    'Tracked Postage': 'Affranchissement suivi',
    'MRW Urgente 24/48 Horas': 'MRW Urgente 24/48 Horas',
    'MRW Urgente 24/48 Horas (Large Order)': 'MRW Urgente 24/48 Horas (grosse commande)',
    'Please enter a valid Zip code for': 'Veuillez saisir un code postal valide pour',
    'No shipping rate is currently available for this destination at checkout. Please contact us before ordering.': 'Aucun tarif d\'expédition n\'est actuellement disponible pour cette destination au paiement. Veuillez nous contacter avant de commander.',
    'Rates shown are the most common small-parts options. Belts, rollers and similar light items usually qualify for the lowest available rate.': 'Les tarifs affichés sont les options les plus courantes pour petites pièces. Les courroies, galets et articles légers similaires bénéficient généralement du tarif le plus bas disponible.',
    'Import fees are included in both United States shipping options shown below.': 'Les frais d\'importation sont inclus dans les deux options d\'expédition vers les États-Unis ci-dessous.',
    'Local currency values are indicative. Small differences may appear at checkout due to exchange-rate movement, rounding, or bank fees.': 'Les valeurs en devise locale sont indicatives. De petits écarts peuvent apparaître au paiement en raison des variations de change, des arrondis ou des frais bancaires.',
    'Order within': 'Commandez dans les',
    'and it ships': 'et votre commande part',
    'today': 'aujourd\'hui',
    'Order now, ships': 'Commandez maintenant, départ',
    '(next working day).': '(jour ouvré suivant).',
    'Estimated:': 'Estimation :',
    'working day': 'jour ouvré',
    'working days': 'jours ouvrés',
  },
  ro: {
    'Import fees are already included in the price shown below.': 'Taxele de import sunt deja incluse în prețul afișat mai jos.',
    'Final price depends on total order weight, shown at checkout.': 'Prețul final depinde de greutatea totală a comenzii, afișat la finalizare.',
    'Enter a valid email address.': 'Introdu o adresă de e-mail validă.',
    'Saving…': 'Se salvează…',
    'Done. We\'ll email {e} the moment it\'s back.': 'Gata. Îți scriem la {e} imediat ce revine în stoc.',
    'Could not save that. Please try again in a moment.': 'Nu am putut salva. Încearcă din nou într-un moment.',
    'on {d}': 'pe {d}',
    'hours': 'ore',
    'Express shipping': 'Expediere expres',
    'UPS Economy': 'UPS Economy',
    'We could not confirm your message was sent.': 'Nu am putut confirma că mesajul tău a fost trimis.',
    'Your text is safe in the form. Please try again, or send it by email with one click:': 'Textul tău este în siguranță în formular. Încearcă din nou sau trimite-l prin e-mail cu un clic:',
    'Try again': 'Încearcă din nou',
    'Message sent': 'Mesaj trimis',
    'A confirmation was sent to <strong>{e}</strong>.': 'O confirmare a fost trimisă la <strong>{e}</strong>.',
    'Could not add to cart': 'Nu s-a putut adăuga în coș',
    'Added': 'Adăugat',
    'Out of stock': 'Stoc epuizat',
    'In stock': 'În stoc',
    'Add to cart': 'Adaugă în coș',
    'Shipped from Portugal. Enter your zip code so we can check regional exceptions.': 'Expediat din Portugalia. Introdu codul poștal ca să putem verifica excepțiile regionale.',
    'Shipped from Portugal. Select your destination to see estimated shipping options.': 'Expediat din Portugalia. Selectează destinația pentru a vedea opțiunile estimate de livrare.',
    'Sorry, we do not ship to French Overseas Territories.': 'Ne pare rău, nu expediem către Teritoriile Franceze de peste mări.',
    'Photos attached. They will be included with your message.': 'Fotografii atașate. Vor fi incluse în mesajul tău.',
    'Photo attached. It will be included with your message.': 'Fotografie atașată. Va fi inclusă în mesajul tău.',
    'Only image files can be attached.': 'Pot fi atașate doar fișiere imagine.',
    'Uploading photo…': 'Se încarcă fotografia…',
    'That photo is too large. Please try one under 8MB.': 'Fotografia este prea mare. Încearcă una sub 8 MB.',
    'That photo could not be uploaded. You can still send the message and email photos afterwards.': 'Fotografia nu a putut fi încărcată. Poți trimite mesajul și fotografiile prin e-mail după aceea.',
    'One moment, your photo is still uploading…': 'Un moment, fotografia ta încă se încarcă…',
    'Added ✓': 'Adăugat ✓',
    'Added to cart': 'Adăugat în coș',
    'Adding…': 'Se adaugă…',
    'Available Service': 'Serviciu disponibil',
    'Cost': 'Cost',
    'Last unit left': 'Ultima unitate',
    'Please enter a Zip code for this destination.': 'Te rugăm introdu un cod poștal pentru această destinație.',
    'Please select a destination country.': 'Te rugăm selectează o țară de destinație.',
    'Send by email instead': 'Trimite prin email în schimb',
    'Sending…': 'Se trimite…',
    'Ticket': 'Tichet',
    'Unavailable': 'Indisponibil',
    'Use the basic form': 'Folosește formularul simplu',
    'We will confirm the belt match. The belt is free, you only pay shipping.': 'Confirmăm potrivirea curelei. Cureaua este gratuită, plătești doar livrarea.',
    'We reply Monday to Friday, and order issues get priority.': 'Răspundem de luni până vineri, iar problemele de comandă au prioritate.',
    'We reply Monday to Friday, 09:00–17:00 Central European Time.': 'Răspundem de luni până vineri, 09:00–17:00 ora Europei Centrale.',
    'tomorrow': 'mâine',
    'Sunday': 'duminică',
    'Monday': 'luni',
    'Tuesday': 'marți',
    'Wednesday': 'miercuri',
    'Thursday': 'joi',
    'Friday': 'vineri',
    'Saturday': 'sâmbătă',
    'Economic Shipping (Small Parts)': 'Expediere economică (piese mici)',
    'Tracked Shipping': 'Expediere cu urmărire',
    'CTT Expresso': 'CTT Expresso',
    'Registered Mail': 'Corespondență înregistrată',
    'Economic Shipping': 'Expediere economică',
    'Economy Shipping (Small Parts)': 'Expediere economică (piese mici)',
    'Small Value ECO Shipping': 'Expediere ECO valoare mică',
    'Tracked Postage': 'Poștă cu urmărire',
    'MRW Urgente 24/48 Horas': 'MRW Urgent 24/48 ore',
    'MRW Urgente 24/48 Horas (Large Order)': 'MRW Urgent 24/48 ore (comandă mare)',
    'Please enter a valid Zip code for': 'Te rugăm introdu un cod poștal valid pentru',
    'No shipping rate is currently available for this destination at checkout. Please contact us before ordering.': 'Momentan nu există un tarif de livrare disponibil pentru această destinație la finalizarea comenzii. Te rugăm contactează-ne înainte de a comanda.',
    'Rates shown are the most common small-parts options. Belts, rollers and similar light items usually qualify for the lowest available rate.': 'Tarifele afișate sunt cele mai comune opțiuni pentru piese mici. Curelele, rolele și articolele ușoare similare se califică de obicei pentru cel mai mic tarif disponibil.',
    'Import fees are included in both United States shipping options shown below.': 'Taxele de import sunt incluse în ambele opțiuni de livrare pentru Statele Unite afișate mai jos.',
    'Local currency values are indicative. Small differences may appear at checkout due to exchange-rate movement, rounding, or bank fees.': 'Valorile în moneda locală sunt orientative. Pot apărea mici diferențe la finalizarea comenzii din cauza fluctuațiilor cursului valutar, rotunjirii sau taxelor bancare.',
    'Order within': 'Comandă în următoarele',
    'and it ships': 'și se expediază',
    'today': 'astăzi',
    'Order now, ships': 'Comandă acum, se expediază',
    '(next working day).': '(următoarea zi lucrătoare).',
    'Estimated:': 'Estimat:',
    'working day': 'zi lucrătoare',
    'working days': 'zile lucrătoare'
  }
};
function rateDelay(d) {
  var t = String(d);
  if (/working days/.test(t)) return t.replace('working days', GT('working days'));
  if (/working day/.test(t))  return t.replace('working day', GT('working day'));
  if (/hours/.test(t))        return t.replace('hours', GT('hours'));
  return GT(t);
}
function GT(str) {
  var loc = (window.WSP && window.WSP.locale) || (document.documentElement && document.documentElement.lang) || 'en';
  loc = String(loc).toLowerCase().split('-')[0];
  var d = GJS_I18N[loc];
  return (d && Object.prototype.hasOwnProperty.call(d, str)) ? d[str] : str;
}


/* ================================================================
 * WSPGeo -- visitor country from the IP, shared by the contact
 * pipeline and the back-in-stock module (separate IIFEs, so this
 * lives on window). Cloudflare's public trace endpoint answers
 * "loc=XX" for THIS visitor's IP; three endpoints in a chain, 2.5s
 * timeout each, result cached for the session. Never blocks -- if
 * every endpoint fails, callers just send an empty country.
 * ================================================================ */
(function () {
  'use strict';
  var GEO_KEY = 'wsp:geo:v1';
  var GEO_URLS = [
    'https://www.cloudflare.com/cdn-cgi/trace',
    'https://one.one.one.one/cdn-cgi/trace',
    'https://cloudflare-dns.com/cdn-cgi/trace'
  ];
  function cached() {
    try { return JSON.parse(sessionStorage.getItem(GEO_KEY) || 'null'); } catch (e) { return null; }
  }
  function name(iso) {
    try { return new Intl.DisplayNames(['en'], { type: 'region' }).of(iso) || ''; } catch (e) { return ''; }
  }
  function detect(i) {
    i = i || 0;
    if (cached() || i >= GEO_URLS.length) return;
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    var timer = setTimeout(function () { try { if (ctl) ctl.abort(); } catch (e) {} }, 2500);
    fetch(GEO_URLS[i], ctl ? { signal: ctl.signal } : {})
      .then(function (r) { return r.text(); })
      .then(function (t) {
        clearTimeout(timer);
        var m = /(?:^|\n)loc=([A-Za-z]{2})/.exec(String(t));
        if (!m) throw new Error('no loc');
        var iso = m[1].toUpperCase();
        try { sessionStorage.setItem(GEO_KEY, JSON.stringify({ iso: iso, name: name(iso) })); } catch (e) {}
      })
      .catch(function () { clearTimeout(timer); detect(i + 1); });
  }
  window.WSPGeo = { detect: detect, cached: cached };
})();

(function () {
  'use strict';

  window.WSP_PIPELINE_V = 4;
  var endpoint = (window.WSP && window.WSP.supportBackend) || '';
  var markers = document.querySelectorAll('[data-wsp-form]');
  /* unconditional boot report: silence is never ambiguous again.
     Readable in console AND by typing: window.WSP_SUPPORT_STATUS */
  window.WSP_SUPPORT_STATUS = { v: 4, endpointConfigured: !!endpoint, formsOnThisPage: markers.length };
  console.info('[WSP] pipeline v4 loaded · endpoint: ' + (endpoint ? 'configured' : 'MISSING') + ' · forms on this page: ' + markers.length);
  if (!endpoint) {
    if (markers.length)
      console.warn('[WSP] support backend URL NOT configured in this theme copy - forms will use the native Shopify pipeline (hCaptcha).');
    return;
  }

  var CORE = { name: 1, email: 1, model: 1, body: 1, photo_links: 1, website: 1 };

  function bindForm(marker) {
    var form = marker.closest('form');
    if (!form) { console.warn('[WSP] marker found but no parent form', marker); return; }
    if (form.getAttribute('data-wsp-bound')) return;
    console.info('[WSP] pipeline v4 bound:', marker.value || 'support');
    form.setAttribute('data-wsp-bound', '1');
    WSPGeo.detect(); /* resolves long before the 3s dwell guard allows a submit */
    var formType = marker.value || 'support';
    var startedAt = Date.now();
    var nativeFallback = false;
    var busy = false;
    var sid = '';
    function newSid() {
      try { sid = crypto.randomUUID(); }
      catch (eu) { sid = 's' + Date.now() + Math.random().toString(36).slice(2, 10); }
    }
    newSid();

    /* honeypot: bots that fill every field give themselves away */
    var hp = document.createElement('input');
    hp.type = 'text'; hp.name = 'contact[website]'; hp.tabIndex = -1;
    hp.autocomplete = 'off'; hp.setAttribute('aria-hidden', 'true');
    hp.style.cssText = 'position:absolute;left:-9999px;height:1px;width:1px;opacity:0;';
    form.appendChild(hp);

    function fieldValue(name) {
      var el = form.querySelector('[name="contact[' + name + ']"]');
      return el ? String(el.value || '').trim() : '';
    }

    /* ABSOLUTE native block: even programmatic form.submit() calls
       from any other script are gated - native submission physically
       cannot happen unless the user explicitly chose the basic form */
    var nativeSubmit = form.submit.bind(form);
    form.submit = function () {
      if (nativeFallback) { console.info('[WSP] user-chosen native submit'); return nativeSubmit(); }
      console.warn('[WSP] blocked a programmatic native form.submit() attempt');
    };

    form.addEventListener('submit', function (e) {
      if (nativeFallback) return; /* deliberate hand-over to Shopify */
      /* ALWAYS swallow the event while a send is in flight: a repeat
         Enter press or double tap must never reach Shopify's endpoint,
         or the owner gets the message twice (once branded, once ugly) */
      e.preventDefault();
      if (busy) return;
      console.info('[WSP] submit intercepted, sending to backend');
      if (!form.checkValidity || form.checkValidity()) {
        busy = true;
        var btn = form.querySelector('[type="submit"]');
        var btnLabel = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = GT('Sending…'); }

        var payload = {
          action: 'message',
          sid: sid,
          form: formType,
          name: fieldValue('name'),
          email: fieldValue('email'),
          model: fieldValue('model'),
          body: fieldValue('body'),
          fields: {},
          photos: [],
          page: location.href,
          /* where the message comes from. geoCountry is automatic, from
             the visitor's IP; country/countryName are the Shopify market
             (a dropdown the customer can change); tz corroborates both.
             None of them is proof - the checkout address is. */
          geoCountry: (WSPGeo.cached() && WSPGeo.cached().iso) || '',
          geoCountryName: (WSPGeo.cached() && WSPGeo.cached().name) || '',
          country: (window.WSP && WSP.country) || '',
          countryName: (window.WSP && WSP.countryName) || '',
          /* which storefront language they are reading - i.e. the
             language to answer them in */
          locale: (window.WSP && WSP.locale) ||
                  (document.documentElement && document.documentElement.lang) || '',
          tz: (function () {
            try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { return ''; }
          })(),
          hp: hp.value,
          dwell: Date.now() - startedAt
        };
        form.querySelectorAll('[name^="contact["]').forEach(function (el) {
          var m = el.name.match(/^contact\[(.+)\]$/);
          if (!m || CORE[m[1]] || m[1] === 'subject') return;
          /* radios/checkboxes only count when checked, else the last
             option always overwrites the chosen one */
          if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
          var v = String(el.value || '').trim();
          if (v) payload.fields[m[1]] = v;
        });
        var linksEl = form.querySelector('[data-photo-links]');
        if (linksEl && linksEl.value) payload.photos = linksEl.value.split('\n').filter(Boolean);

        function postOnce(attempt) {
          return fetch(endpoint, { method: 'POST', body: JSON.stringify(payload) })
            .then(function (r) { return r.text(); })
            .then(function (txt) {
              try { return JSON.parse(txt); }
              catch (ep) { throw new Error('attempt ' + attempt + ': bad response (' + txt.slice(0, 60) + ')'); }
            });
        }
        function wait(ms) { return new Promise(function (res) { setTimeout(res, ms); }); }
        function crumb(err) {
          try {
            console.warn('[WSP] support send issue:', err);
            localStorage.setItem('wsp_support_err', new Date().toISOString() + ' ' + String(err && err.message || err));
          } catch (e2) {}
        }
        function showSendError() {
          busy = false;
          if (btn) { btn.disabled = false; btn.textContent = btnLabel; }
          var old = form.querySelector('.wspmsg-err');
          if (old) old.remove();
          var box = document.createElement('div');
          box.className = 'wspmsg-err';
          box.setAttribute('role', 'alert');
          var mailSubject = encodeURIComponent('[' + formType + '] ' + (payload.model || 'support request'));
          var mailBody = encodeURIComponent(payload.body + '\n\nModel: ' + (payload.model || '-') + '\nName: ' + payload.name);
          box.innerHTML =
            '<p class="wspmsg-err__title">' + GT('We could not confirm your message was sent.') + '</p>' +
            '<p class="wspmsg-err__note">' + GT('Your text is safe in the form. Please try again, or send it by email with one click:') + '</p>' +
            '<div class="wspmsg-err__actions">' +
              '<button type="submit" class="btn btn--primary btn--sm">' + GT('Try again') + '</button>' +
              '<a class="btn btn--outline btn--sm" href="mailto:info@webspareparts.com?subject=' + mailSubject + '&body=' + mailBody + '"'+ GT('Send by email instead') +'</a>' +
              '<button type="button" class="btn btn--outline btn--sm" data-wsp-basic'+ GT('Use the basic form') +'</button>' +
            '</div>';
          var submitBtn = form.querySelector('[type="submit"]');
          (submitBtn && submitBtn.parentNode === form ? form : form).insertBefore(box, submitBtn || null);
          var basic = box.querySelector('[data-wsp-basic]');
          if (basic) basic.addEventListener('click', function () {
            /* USER-initiated hand-over to Shopify's pipeline (they may
               see a human-verification step) - never automatic */
            nativeFallback = true;
            form.submit();
          });
          box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        /* three idempotent attempts: the sid makes retries safe (the
           backend returns the SAME ticket for a repeated sid, never a
           duplicate email). NO automatic Shopify fallback: a lost
           RESPONSE with a delivered REQUEST was producing a duplicate
           ugly email plus a human-verification page. */
        postOnce(1)
          .catch(function (e1) { crumb(e1); return wait(1500).then(function () { return postOnce(2); }); })
          .catch(function (e2) { crumb(e2); return wait(4000).then(function () { return postOnce(3); }); })
          .then(function (data) {
            if (!data || !data.ok) throw new Error((data && data.error) || 'backend said no');
            var panel = document.createElement('div');
            panel.className = 'wspmsg-ok';
            panel.setAttribute('role', 'status');
            panel.innerHTML =
              '<div class="wspmsg-ok__badge" aria-hidden="true">&#10003;</div>' +
              '<h3 class="wspmsg-ok__title">' + GT('Message sent') + '</h3>' +
              '<p class="wspmsg-ok__ticket">Ticket <span class="mono">' + String(data.ticket || '').replace(/[^\w\-]/g, '') + '</span></p>' +
              '<p class="wspmsg-ok__note">' + (formType === 'order' ? GT('We reply Monday to Friday, and order issues get priority.') : formType === 'free-sample' ? GT('We will confirm the belt match. The belt is free, you only pay shipping.') : GT('We reply Monday to Friday, 09:00\u201317:00 Central European Time.')) +
              (payload.email ? ' ' + GT('A confirmation was sent to <strong>{e}</strong>.').replace('{e}', payload.email.replace(/</g, '&lt;')) : '') + '</p>';
            form.replaceWith(panel);
            panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
          })
          .catch(function (err) {
            crumb(err);
            showSendError();
          });
      }
    });
  }

  markers.forEach(bindForm);
  window.WSP = window.WSP || {};
  window.WSP.bindSupportForm = function (node) {
    if (!node) return;
    var marker = (node.matches && node.matches('[data-wsp-form]'))
      ? node
      : (node.querySelector && node.querySelector('[data-wsp-form]'));
    if (marker) bindForm(marker);
  };
})();

/* =============================================================
   WebSpareParts Compatibility Engine - global.js (v4)
   Site-wide UI behaviour. Compatibility logic lives in finder.js.
   ============================================================= */
(function () {
  'use strict';

  var WSP = window.WSP || {};
  var G_ROOT = (WSP.rootUrl && WSP.rootUrl !== '/') ? WSP.rootUrl.replace(/\/$/, '') : '';
  function gLurl(p) { if (/^https?:/i.test(p)) return p; if (p.charAt(0) !== '/') return p; return G_ROOT + p; }
  var COMPAT_URL = WSP.compatUrl || '/pages/compatibility-database';
  /* locale root: '/' on the primary market, '/it-it' etc. on others */
  var LROOT = (WSP.rootUrl && WSP.rootUrl !== '/') ? String(WSP.rootUrl).replace(/\/$/, '') : '';
  function lurl(path) {
    if (/^https?:/i.test(path)) return path;
    if (String(path).charAt(0) !== '/') return path;
    if (LROOT && (path === LROOT || String(path).indexOf(LROOT + '/') === 0)) return path;
    return LROOT + path;
  }
  var MEMORY_KEY = 'wsp_model_memory_v1';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  /* ------------------------------------------------ money format */
  function fmtPrice(cents) {
    if (cents == null || isNaN(cents)) return '';
    return '\u20AC' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /* ------------------------------------------------------ toast */
  function showToast(text, showLink) {
    if (window.__wspUpsellActive) return; /* finder shows its own panel */
    var toast = document.getElementById('wsp-toast');
    if (!toast) return;
    var txt = toast.querySelector('.wsp-toast__text');
    var link = toast.querySelector('.wsp-toast__link');
    if (txt) txt.textContent = text;
    if (link) link.hidden = !showLink;
    toast.hidden = false;
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () { toast.hidden = true; }, 6000);
  }
  on($('#wsp-toast .wsp-toast__close'), 'click', function () {
    var toast = document.getElementById('wsp-toast');
    if (toast) toast.hidden = true;
  });

  function bumpCartCount(count) {
    $all('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', !count);
    });
  }

  /* ================================================== HEADER === */
  (function header() {
    var menu = $('[data-mobile-menu]');
    var openBtn = $('[data-menu-open]');
    if (menu && openBtn) {
      function setMenu(open) {
        menu.hidden = !open;
        openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.documentElement.classList.toggle('menu-open', open);
        if (open) {
          var focusable = menu.querySelector('a, button');
          if (focusable) focusable.focus();
        } else {
          openBtn.focus();
        }
      }
      on(openBtn, 'click', function () { setMenu(menu.hidden); });
      $all('[data-menu-close]', menu).forEach(function (btn) {
        on(btn, 'click', function () { setMenu(false); });
      });
      on(document, 'keydown', function (e) {
        if (e.key === 'Escape' && !menu.hidden) setMenu(false);
      });
    }

    var searchToggle = $('[data-search-toggle]');
    var searchPanel = $('[data-search-panel]');
    if (searchToggle && searchPanel) {
      on(searchToggle, 'click', function () {
        var open = searchPanel.hidden;
        searchPanel.hidden = !open;
        searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var input = searchPanel.querySelector('input[type="search"], input[type="text"]');
          if (input) input.focus();
        }
      });
      on(document, 'keydown', function (e) {
        if (e.key === 'Escape' && !searchPanel.hidden) {
          searchPanel.hidden = true;
          searchToggle.setAttribute('aria-expanded', 'false');
          searchToggle.focus();
        }
      });
    }
  })();

  /* ============================== CLEAN PRODUCT TITLES (display) */
  /* Strips leading internal catalogue codes like "F0016 " from card
     titles. Full title is preserved in the title attribute. */
  var LEAD_CODE_RE = /^([A-Z]{1,4}\d{2,5}[A-Z]?)\s+(.{4,})$/;
  function cleanTitles(root) {
    $all('[data-clean-title]', root).forEach(function (el) {
      if (el.dataset.cleaned) return;
      el.dataset.cleaned = '1';
      var full = el.textContent.trim();
      var m = full.match(LEAD_CODE_RE);
      if (!m) return;
      if (!el.getAttribute('title')) el.setAttribute('title', full);
      el.textContent = m[2];
      var card = el.closest('.pcard');
      if (card) {
        var ref = card.querySelector('[data-product-ref]');
        if (ref && !ref.textContent.trim()) ref.textContent = 'REF ' + m[1];
      }
    });
  }
  cleanTitles(document);

  /* ======================================= QUICK ADD (cards) === */
  function bindQuickAdd(root) {
    $all('[data-quick-add]', root).forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      on(btn, 'click', function (e) {
        e.preventDefault();
        var id = parseInt(btn.getAttribute('data-quick-add'), 10);
        if (!id) return;
        var oldText = btn.textContent;
        btn.disabled = true;
        btn.textContent = GT('Adding…');
        fetch((WSP.cartAddUrl ? WSP.cartAddUrl + '.js' : gLurl('/cart/add.js')), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || GT('Could not add to cart')); });
            return r.json();
          })
          .then(function () { return fetch(gLurl('/cart.js')).then(function (r) { return r.json(); }); })
          .then(function (cart) {
            bumpCartCount(cart.item_count);
            btn.textContent = GT('Added') + ' \u2713';
            showToast(GT('Added to cart'), true);
            setTimeout(function () { btn.textContent = oldText; btn.disabled = false; }, 1800);
          })
          .catch(function (err) {
            btn.textContent = oldText;
            btn.disabled = false;
            showToast(err.message || GT('Could not add to cart'), false);
          });
      });
    });
  }
  bindQuickAdd(document);

  /* ================================== BACK-IN-STOCK ALERTS ===== */
  (function restockAlert() {
    var box = $('[data-restock]');
    if (!box) return;
    var form = box.querySelector('[data-restock-form]');
    var msg = box.querySelector('[data-restock-msg]');
    var input = form && form.querySelector('input[type="email"]');
    var btn = form && form.querySelector('button[type="submit"]');
    if (!form || !input || !btn) return;
    var endpoint = (window.WSP && WSP.supportBackend) || '';
    if (!endpoint) { box.hidden = true; return; }
    WSPGeo.detect(); /* so the owner alert can say where the request came from */
    function say(t, ok) {
      if (!msg) return;
      msg.hidden = false;
      msg.textContent = t;
      msg.className = 'restock__msg ' + (ok ? 'restock__msg--ok' : 'restock__msg--err');
    }
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var email = String(input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        say(GT('Enter a valid email address.'), false);
        input.focus();
        return;
      }
      var vid = $('[data-variant-id]');
      var payload = {
        action: 'restock',
        email: email,
        handle: box.getAttribute('data-handle') || '',
        variantId: (vid && vid.value) || '',
        title: box.getAttribute('data-title') || '',
        url: box.getAttribute('data-url') || location.href.split('?')[0],
        locale: (document.documentElement.lang || 'en'),
        /* same origin signals as a support message: automatic country from
           the IP, the market they are browsing, and the browser timezone */
        geoCountry: (WSPGeo.cached() && WSPGeo.cached().iso) || '',
        geoCountryName: (WSPGeo.cached() && WSPGeo.cached().name) || '',
        country: (window.WSP && WSP.country) || '',
        countryName: (window.WSP && WSP.countryName) || '',
        tz: (function () {
          try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { return ''; }
        })()
      };
      btn.disabled = true;
      say(GT('Saving…'), true);
      /* text/plain body keeps this a CORS "simple request" */
      fetch(endpoint, { method: 'POST', body: JSON.stringify(payload) })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (!j || !j.ok) throw new Error((j && j.error) || 'failed');
          form.hidden = true;
          say(GT("Done. We'll email {e} the moment it's back.").replace('{e}', email), true);
        })
        .catch(function () {
          btn.disabled = false;
          say(GT('Could not save that. Please try again in a moment.'), false);
        });
    });
  })();

  /* ================================== PRODUCT PAGE: variants === */
  (function productForm() {
    var variantsScript = $('script[data-variants-json]');
    if (!variantsScript) return;
    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }
    if (!Array.isArray(variants)) return;

    var selects = $all('[data-option-select]');
    var idInput = $('[data-variant-id]');
    var priceEl = $('[data-product-price]');
    var stockEl = $('[data-product-stock]');
    var addBtn = $('[data-add-to-cart]');
    var addText = $('[data-add-to-cart-text]');

    function currentSelection() {
      var opts = [];
      selects
        .slice()
        .sort(function (a, b) {
          return parseInt(a.getAttribute('data-option-index'), 10) - parseInt(b.getAttribute('data-option-index'), 10);
        })
        .forEach(function (s) { opts[parseInt(s.getAttribute('data-option-index'), 10)] = s.value; });
      return opts;
    }

    function matchVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var vOpts = v.options || [v.option1, v.option2, v.option3].filter(function (o) { return o != null; });
        var ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] != null && vOpts[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function stockLabel(v) {
      if (!v) return '';
      if (!v.available) return '<span class="stock stock--out">' + GT('Out of stock') + '</span>';
      var qty = v.inventory_quantity;
      if (typeof qty === 'number' && qty === 1) return '<span class="stock stock--last">Last unit left</span>';
      return '<span class="stock stock--in">' + GT('In stock') + '</span>';
    }

    function applyVariant(v) {
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = GT('Unavailable');
        var restockEl0 = $('[data-restock]');
        if (restockEl0) restockEl0.hidden = false;
        return;
      }
      var restockEl = $('[data-restock]');
      if (restockEl) restockEl.hidden = !!v.available;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = fmtPrice(v.price);
      if (stockEl) stockEl.innerHTML = stockLabel(v);
      if (addBtn) addBtn.disabled = !v.available;
      if (addText) addText.textContent = v.available ? GT('Add to cart') : GT('Out of stock');
      try {
        var url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url.toString());
      } catch (e) {}
    }

    selects.forEach(function (s) {
      on(s, 'change', function () { applyVariant(matchVariant(currentSelection())); });
    });

    /* quantity stepper */
    $all('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input[type="number"], input[name="quantity"]');
      if (!input) return;
      on(wrap.querySelector('[data-qty-minus]'), 'click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, v - 1);
      });
      on(wrap.querySelector('[data-qty-plus]'), 'click', function () {
        var v = parseInt(input.value, 10) || 1;
        var max = parseInt(input.getAttribute('max'), 10);
        input.value = max ? Math.min(max, v + 1) : v + 1;
      });
    });
  })();

  /* ==================================== PRODUCT PAGE: gallery == */
  (function gallery() {
    var main = $('[data-gallery-main]');
    if (!main) return;
    $all('[data-gallery-thumb]').forEach(function (thumb) {
      on(thumb, 'click', function () {
        var src = thumb.getAttribute('data-gallery-thumb');
        if (!src) return;
        main.src = src;
        var alt = thumb.getAttribute('data-gallery-alt') || (thumb.querySelector('img') && thumb.querySelector('img').alt) || '';
        if (alt) main.alt = alt;
        $all('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  })();

  /* ============================================ RECOMMENDATIONS */
  (function recommendations() {
    var box = $('[data-recommendations]');
    if (!box) return;
    var url = box.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('[data-recommendations]');
        if (inner && inner.innerHTML.trim()) {
          box.innerHTML = inner.innerHTML;
          cleanTitles(box);
          bindQuickAdd(box);
        } else {
          box.hidden = true;
        }
      })
      .catch(function () { box.hidden = true; });
  })();

  /* =========================================== MISC TOGGLES === */
  $all('[data-toggle-target]').forEach(function (btn) {
    on(btn, 'click', function () {
      var target = $(btn.getAttribute('data-toggle-target'));
      if (target) target.hidden = !target.hidden;
    });
  });

  (function loginRecover() {
    var link = $('[data-show-recover]');
    var panel = $('[data-recover-panel]');
    if (!link || !panel) return;
    on(link, 'click', function (e) {
      e.preventDefault();
      panel.hidden = !panel.hidden;
      if (!panel.hidden) {
        var input = panel.querySelector('input');
        if (input) input.focus();
      }
    });
    if (location.hash === '#recover') panel.hidden = false;
  })();

  $all('select[data-auto-submit]').forEach(function (sel) {
    on(sel, 'change', function () {
      if (sel.form) sel.form.submit();
    });
  });

  /* =============================== ADDRESSES: country/province */
  (function addressCountries() {
    var selects = $all('[data-address-country-select]');
    if (!selects.length || typeof Shopify === 'undefined' || !Shopify.CountryProvinceSelector) return;
    selects.forEach(function (countrySelect) {
      var provinceSelect = null;
      /* province select is the next select[name="address[province]"] in the same form */
      var form = countrySelect.closest('form');
      if (form) provinceSelect = form.querySelector('select[name="address[province]"]');
      if (!countrySelect.id) return;
      if (provinceSelect && !provinceSelect.id) provinceSelect.id = countrySelect.id + '-province';
      var provinceWrap = provinceSelect ? provinceSelect.closest('.field') : null;
      if (provinceWrap && !provinceWrap.id) provinceWrap.id = countrySelect.id + '-province-wrap';
      try {
        new Shopify.CountryProvinceSelector(countrySelect.id, provinceSelect ? provinceSelect.id : '', {
          hideElement: provinceWrap ? provinceWrap.id : ''
        });
      } catch (e) {}
    });
  })();

  /* ========================================== MODEL MEMORY BAR */
  function memoryLoad() {
    if (window.WSPMemory && window.WSPMemory.load) return window.WSPMemory.load();
    try {
      var m = JSON.parse(localStorage.getItem(MEMORY_KEY));
      if (m && m.brand && m.model && !m.dismissed) return m;
    } catch (e) {}
    return null;
  }
  function memoryDismiss() {
    try {
      var m = JSON.parse(localStorage.getItem(MEMORY_KEY)) || {};
      m.dismissed = true;
      localStorage.setItem(MEMORY_KEY, JSON.stringify(m));
    } catch (e) {}
  }
  function compatLink(m) {
    return lurl(COMPAT_URL) + '?brand=' + encodeURIComponent(m.brand) + '&model=' + encodeURIComponent(m.model);
  }

  (function memoryBar() {
    var bar = document.getElementById('model-memory');
    if (!bar) return;
    /* Never show the bar on the compatibility page itself */
    if (location.pathname.indexOf('/pages/compatibility-database') === 0) return;
    var pageType = WSP.pageType || '';
    if (pageType !== 'product' && pageType !== 'collection' && pageType !== 'list-collections') return;
    var m = memoryLoad();
    if (!m) return;
    var label = bar.querySelector('[data-memory-model]');
    if (label) label.textContent = (m.brand + ' ' + m.model).trim();
    var view = bar.querySelector('[data-memory-view]');
    if (view) view.href = compatLink(m);
    var change = bar.querySelector('[data-memory-change]');
    if (change) change.href = lurl(COMPAT_URL);
    on(bar.querySelector('[data-memory-dismiss]'), 'click', function () {
      memoryDismiss();
      bar.hidden = true;
    });
    bar.hidden = false;
  })();

  /* ============================= PRODUCT PAGE: memory cross-sell */
  (function productMemory() {
    var box = $('[data-product-memory]');
    if (!box) return;
    var m = memoryLoad();
    if (!m) return;
    var label = box.querySelector('[data-memory-model]');
    if (label) label.textContent = (m.brand + ' ' + m.model).trim();
    var view = box.querySelector('[data-memory-view]');
    if (view) view.href = compatLink(m);
    box.hidden = false;
  })();
})();

/* ==========================================================================
   Shipping estimator - legacy static rate calculator, fully ported.
   Rate tables, PT/ES island zones, FR overseas refusal, delivery windows
   over Portuguese working days, local currency approximations.
   ========================================================================== */
(function () {
  'use strict';
  var box = document.querySelector('[data-ship-estimate]');
  if (!box) return;

  var toggle = box.querySelector('[data-ship-toggle]');
  var body = box.querySelector('[data-ship-body]');
  var helper = box.querySelector('[data-ship-helper]');
  var country = box.querySelector('[data-ship-country]');
  var zipRow = box.querySelector('[data-ship-ziprow]');
  var zip = box.querySelector('[data-ship-zip]');
  var go = box.querySelector('[data-ship-go]');
  var res = box.querySelector('[data-ship-result]');
  var warning = box.querySelector('[data-ship-warning]');
  if (!toggle || !body || !country || !res) return;

  toggle.addEventListener('click', function () {
    var open = body.hidden;
    body.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    box.classList.toggle('is-open', open);
  });

  /* ---------- Portugal holidays (shared with dispatch) ---------- */
  var HOLIDAYS = ['01-01','04-25','05-01','06-10','08-15','10-05','11-01','12-01','12-08','12-25',
    '2025-03-04','2025-04-18','2025-04-20','2025-05-06','2025-06-19',
    '2026-02-17','2026-04-03','2026-04-05','2026-04-21','2026-06-04',
    '2027-02-09','2027-03-26','2027-03-28','2027-04-13','2027-05-27'];
  function pad2(n) { return String(n).padStart(2, '0'); }
  function isHoliday(d) {
    var md = pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
    return HOLIDAYS.indexOf(md) !== -1 || HOLIDAYS.indexOf(d.getFullYear() + '-' + md) !== -1;
  }
  function getDeliveryRange(minDays, maxDays) {
    function addWorkDays(startDate, days) {
      var cur = new Date(startDate), added = 0;
      while (added < days) {
        cur.setDate(cur.getDate() + 1);
        if (cur.getDay() !== 0 && cur.getDay() !== 6 && !isHoliday(cur)) added++;
      }
      return cur;
    }
    var opts = { month: 'short', day: 'numeric' };
    var today = new Date();
    return addWorkDays(today, minDays).toLocaleDateString((window.WSP && window.WSP.locale) || 'en-US', opts) + ' - ' +
           addWorkDays(today, maxDays).toLocaleDateString((window.WSP && window.WSP.locale) || 'en-US', opts);
  }

  /* ---------- rate tables (ported verbatim) ---------- */
  var EE = [
    { n: 'Economic Shipping (Small Parts)', d: '5-10 working days', min: 5, max: 10, amount: 2.42, currency: 'EUR', from: true },
    { n: 'Tracked Shipping', d: '5-10 working days', min: 5, max: 10, amount: 5.80, currency: 'EUR', from: true }
  ];
  var Z680_10_20 = [{ n: 'Tracked Shipping', d: '10-20 working days', min: 10, max: 20, amount: 6.80, currency: 'EUR', from: true }];
  var Z680_15_35 = [{ n: 'Tracked Shipping', d: '15-35 working days', min: 15, max: 35, amount: 6.80, currency: 'EUR', from: true }];

  var DATA = {
    Portugal_MAIN: [
      { n: 'CTT Expresso', d: '1-2 working days', min: 1, max: 2, amount: 5.85, currency: 'EUR' },
      { n: 'Economic Shipping (Small Parts)', d: '5-10 working days', min: 5, max: 10, amount: 2.00, currency: 'EUR' }
    ],
    Portugal_ISLANDS: [
      { n: 'Economic Shipping (Small Parts)', d: '5-10 working days', min: 5, max: 10, amount: 2.42, currency: 'EUR' },
      { n: 'Tracked Shipping', d: '10-20 working days', min: 10, max: 20, amount: 4.20, currency: 'EUR' }
    ],
    Spain_MAIN: [
      { n: 'CTT Expresso', d: 'Express shipping', min: 1, max: 3, amount: 4.75, currency: 'EUR' },
      { n: 'MRW Urgente 24/48 Horas', d: '24-48 hours', min: 1, max: 2, amount: 5.90, currency: 'EUR' },
      { n: 'MRW Urgente 24/48 Horas (Large Order)', d: '24-48 hours', min: 1, max: 2, amount: 7.50, currency: 'EUR' },
      { n: 'Economic Shipping (Small Parts)', d: '5-10 working days', min: 5, max: 10, amount: 2.42, currency: 'EUR' }
    ],
    Spain_ISLANDS: [
      { n: 'Economic Shipping (Small Parts)', d: '5-10 working days', min: 5, max: 10, amount: 2.42, currency: 'EUR' },
      { n: 'Tracked Shipping', d: '15-35 working days', min: 15, max: 35, amount: 5.99, currency: 'EUR' }
    ],
    Austria: EE, Belgium: EE, Croatia: EE, Czechia: EE, Denmark: EE, Estonia: EE, Finland: EE,
    France: EE, Germany: EE, Greece: EE, Hungary: EE, Ireland: EE, Italy: EE, Latvia: EE,
    Lithuania: EE, Luxembourg: EE, Netherlands: EE, Poland: EE, Slovakia: EE, Slovenia: EE,
    Sweden: EE, Switzerland: EE, Norway: EE,
    Bulgaria: [
      { n: 'Economic Shipping (Small Parts)', d: '5-10 working days', min: 5, max: 10, amount: 2.42, currency: 'EUR', from: true },
      { n: 'Tracked Shipping', d: '5-10 working days', min: 5, max: 10, amount: 5.80, currency: 'EUR', from: true }
    ],
    Romania: [
      { n: 'Economic Shipping (Small Parts)', d: '5-10 working days', min: 5, max: 10, amount: 2.65, currency: 'EUR', from: true },
      { n: 'Tracked Shipping', d: '5-10 working days', min: 5, max: 10, amount: 5.80, currency: 'EUR', from: true }
    ],
    Malta: EE, 'United Kingdom': EE, Iceland: EE,
    Liechtenstein: [
      { n: 'Economic Shipping (Small Parts)', d: '5-10 working days', min: 5, max: 10, amount: 2.42, currency: 'EUR' },
      { n: 'Tracked Shipping', d: '15-35 working days', min: 15, max: 35, amount: 6.80, currency: 'EUR', from: true }
    ],
    'North Macedonia': [{ n: 'Tracked Shipping', d: '15-35 working days', min: 15, max: 35, amount: 8.15, currency: 'EUR', from: true }],
    Moldova: [{ n: 'Tracked Shipping', d: '15-35 working days', min: 15, max: 35, amount: 6.90, currency: 'EUR', from: true }],
    Canada: [
      { n: 'Economy Shipping (Small Parts)', d: '10-15 working days', min: 10, max: 15, amount: 3.25, currency: 'EUR', from: true },
      { n: 'Tracked Shipping', d: '10-20 working days', min: 10, max: 20, amount: 6.70, currency: 'EUR', from: true }
    ],
    'United States': [
      { n: 'Tracked Postage', d: '5-10 working days', min: 5, max: 10, amount: 8.95, currency: 'EUR', from: true, weightNote: true }
    ],
    Brazil: [
      { n: 'Economy Shipping (Small Parts)', d: '10-15 working days', min: 10, max: 15, amount: 3.25, currency: 'EUR', from: true },
      { n: 'Tracked Shipping', d: '15-35 working days', min: 15, max: 35, amount: 6.80, currency: 'EUR', from: true }
    ],
    Australia: [
      { n: 'Small Value ECO Shipping', d: '20-30 working days', min: 20, max: 30, amount: 2.42, currency: 'EUR', from: true },
      { n: 'Tracked Shipping', d: '15-35 working days', min: 15, max: 35, amount: 6.80, currency: 'EUR', from: true }
    ],
    'New Zealand': [
      { n: 'Small Value ECO Shipping', d: '20-30 working days', min: 20, max: 30, amount: 2.42, currency: 'EUR', from: true },
      { n: 'Tracked Shipping', d: '15-35 working days', min: 15, max: 35, amount: 6.80, currency: 'EUR', from: true }
    ],
    Japan: [
      { n: 'Small Value ECO Shipping', d: '20-30 working days', min: 20, max: 30, amount: 3.25, currency: 'EUR', from: true },
      { n: 'Tracked Shipping', d: '15-35 working days', min: 15, max: 35, amount: 6.80, currency: 'EUR', from: true }
    ],
    India: [{ n: 'Tracked Shipping', d: '15-35 working days', min: 15, max: 35, amount: 6.90, currency: 'EUR', from: true }],
    'New Caledonia': Z680_15_35, 'Hong Kong SAR': Z680_15_35, Singapore: Z680_15_35,
    'South Korea': Z680_15_35, Thailand: Z680_15_35, Indonesia: Z680_15_35, Malaysia: Z680_15_35,
    Philippines: Z680_15_35, Albania: Z680_15_35, Andorra: Z680_15_35,
    'Bosnia and Herzegovina': Z680_15_35, 'Bosnia & Herzegovina': Z680_15_35, '\u00c5land Islands': Z680_15_35,
    'Faroe Islands': Z680_10_20, Georgia: Z680_10_20, Gibraltar: Z680_10_20, 'Isle of Man': Z680_10_20,
    Jersey: Z680_10_20, Guernsey: Z680_10_20, Monaco: Z680_10_20, Montenegro: Z680_10_20,
    'San Marino': Z680_10_20, Serbia: Z680_10_20, 'Svalbard and Jan Mayen': Z680_10_20, 'Svalbard & Jan Mayen': Z680_10_20,
    Argentina: Z680_15_35, Bolivia: Z680_15_35, Chile: Z680_15_35, Colombia: Z680_15_35,
    Ecuador: Z680_15_35, 'El Salvador': Z680_15_35, Guatemala: Z680_15_35, Honduras: Z680_15_35,
    Mexico: Z680_15_35, Panama: Z680_15_35, Paraguay: Z680_15_35, Peru: Z680_15_35,
    Uruguay: [{ n: 'Tracked Shipping', d: '10-20 working days', min: 10, max: 20, amount: 7.80, currency: 'EUR', from: true }], Jamaica: Z680_15_35,
    'Saudi Arabia': Z680_10_20, 'United Arab Emirates': Z680_10_20, Armenia: Z680_15_35,
    Azerbaijan: Z680_15_35, Jordan: Z680_15_35, Kazakhstan: Z680_10_20, Kyrgyzstan: Z680_10_20,
    Laos: Z680_15_35, 'Macao SAR': Z680_15_35, Tajikistan: Z680_10_20, Turkmenistan: Z680_15_35,
    Uzbekistan: Z680_15_35, Vietnam: Z680_15_35, Guadeloupe: Z680_15_35, Egypt: Z680_15_35, Madagascar: Z680_15_35
  };

  var FX = { EUR: 1, USD: 1.1392, JPY: 184.02, CZK: 24.206, DKK: 7.4749, GBP: 0.862, HUF: 354.58,
    PLN: 4.2825, RON: 5.2472, SEK: 11.0585, CHF: 0.9225, ISK: 144, NOK: 11.143, TRY: 52.9496,
    AUD: 1.6423, BRL: 5.8925, CAD: 1.6162, HKD: 8.9313, IDR: 20416.12, ILS: 3.4141, INR: 107.928,
    KRW: 1749.98, MXN: 19.9201, MYR: 4.7169, NZD: 2.0065, PHP: 69.551, SGD: 1.4763, THB: 37.821 };

  var LOCAL = { Austria: 'EUR', Belgium: 'EUR', Bulgaria: 'EUR', Croatia: 'EUR', Cyprus: 'EUR',
    Estonia: 'EUR', Finland: 'EUR', France: 'EUR', Germany: 'EUR', Greece: 'EUR', Ireland: 'EUR',
    Italy: 'EUR', Latvia: 'EUR', Lithuania: 'EUR', Luxembourg: 'EUR', Malta: 'EUR', Netherlands: 'EUR',
    Portugal: 'EUR', Slovakia: 'EUR', Slovenia: 'EUR', Spain: 'EUR', Andorra: 'EUR', Monaco: 'EUR',
    Montenegro: 'EUR', 'San Marino': 'EUR', Guadeloupe: 'EUR',
    Czechia: 'CZK', Denmark: 'DKK', Hungary: 'HUF', Poland: 'PLN', Romania: 'RON', Sweden: 'SEK',
    'United Kingdom': 'GBP', Guernsey: 'GBP', Jersey: 'GBP', 'Isle of Man': 'GBP', Gibraltar: 'GBP',
    Switzerland: 'CHF', Liechtenstein: 'CHF', Norway: 'NOK', 'Svalbard and Jan Mayen': 'NOK', 'Svalbard & Jan Mayen': 'NOK',
    Iceland: 'ISK', Canada: 'CAD',
    Brazil: 'BRL', Mexico: 'MXN', Australia: 'AUD', 'New Zealand': 'NZD', Japan: 'JPY', India: 'INR',
    'Hong Kong SAR': 'HKD', Indonesia: 'IDR', Malaysia: 'MYR', Philippines: 'PHP',
    Singapore: 'SGD', 'South Korea': 'KRW', Thailand: 'THB' };

  var NEEDS_ZIP = { France: true, Portugal: true, Spain: true };

  function fmtMoney(amount, currency) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency,
        maximumFractionDigits: ['JPY', 'KRW', 'IDR', 'ISK', 'HUF'].indexOf(currency) !== -1 ? 0 : 2 }).format(amount);
    } catch (e) { return currency + ' ' + amount.toFixed(2); }
  }
  function priceLine(rate, cn) {
    var src = rate.currency || 'EUR', amt = rate.amount;
    var local = LOCAL[cn] || src;
    var prefix = rate.from ? 'from ' : '';
    var eur = src === 'EUR' ? amt : amt / FX[src];
    var eurText = fmtMoney(eur, 'EUR');
    if (local === src || !FX[src] || !FX[local]) {
      var main = fmtMoney(amt, src);
      return src === 'EUR' ? prefix + main : prefix + main + '<span class="shipest__approx">approx. ' + eurText + '</span>';
    }
    return prefix + fmtMoney(eur * FX[local], local) + '<span class="shipest__approx">approx. ' + eurText + '</span>';
  }
  function usesConverted(rate, cn) {
    var src = rate.currency || 'EUR', local = LOCAL[cn] || src;
    return src === 'EUR' && local !== 'EUR' && Boolean(FX[local]);
  }

  function updateZipState() {
    var cn = country.value;
    var required = Boolean(NEEDS_ZIP[cn]);
    if (zipRow) zipRow.hidden = !required;
    if (zip) { zip.required = required; if (!required) zip.value = ''; }
    if (helper) helper.textContent = required
      ? GT('Shipped from Portugal. Enter your zip code so we can check regional exceptions.')
      : GT('Shipped from Portugal. Select your destination to see estimated shipping options.');
  }

  function calc() {
    var cn = country.value;
    var zp = zip ? zip.value.trim() : '';
    warning.hidden = true;
    res.hidden = false;
    if (!cn) { res.innerHTML = '<p class="shipest__err">' + GT('Please select a destination country.') + '</p>'; return; }
    if (NEEDS_ZIP[cn] && !zp) { res.innerHTML = '<p class="shipest__err">' + GT('Please enter a Zip code for this destination.') + '</p>'; return; }

    var key = cn, validZip = true;
    if (cn === 'France' && (zp.indexOf('97') === 0 || zp.indexOf('98') === 0)) {
      res.innerHTML = '<p class="shipest__err">' + GT('Sorry, we do not ship to French Overseas Territories.') + '</p>'; return;
    }
    if (cn === 'Portugal') {
      if (zp.charAt(0) === '9') key = 'Portugal_ISLANDS';
      else if ('12345678'.indexOf(zp.charAt(0)) !== -1) key = 'Portugal_MAIN';
      else validZip = false;
    }
    if (cn === 'Spain') {
      if (zp.indexOf('07') === 0) key = 'Spain_ISLANDS';
      else if (zp.charAt(0) === '0' || '12345'.indexOf(zp.charAt(0)) !== -1) key = 'Spain_MAIN';
      else validZip = false;
    }
    if (!validZip) { res.innerHTML = '<p class="shipest__err">' + GT('Please enter a valid Zip code for') + ' ' + cn + '.</p>'; return; }

    var rates = DATA[key];
    if (!rates || !rates.length) {
      res.innerHTML = '<p class="shipest__err">' + GT('No shipping rate is currently available for this destination at checkout. Please contact us before ordering.') + '</p>';
      return;
    }

    var html = '<p class="shipest__intro">' + GT('Rates shown are the most common small-parts options. Belts, rollers and similar light items usually qualify for the lowest available rate.') + '</p>';
    if (cn === 'United States') {
      html += '<p class="shipest__usnote">&#10003; ' + GT('Import fees are already included in the price shown below.') + '</p>';
    }
    html += '<div class="shipest__head"><span>' + GT('Available Service') + '</span><span>' + GT('Cost') + '</span></div>';
    rates.forEach(function (r) {
      html += '<div class="shipest__rate">' +
        '<div class="shipest__rate-info">' +
          '<span class="shipest__rate-name">' + GT(r.n) + '</span>' +
          '<span class="shipest__rate-days">&#9201;&#65039; ' + rateDelay(r.d) + '</span>' +
          '<span class="shipest__rate-eta">&#128666; ' + GT('Estimated:') + ' ' + getDeliveryRange(r.min, r.max) + '</span>' +
          (r.weightNote ? '<span class="shipest__rate-weight">&#9878;&#65039; ' + GT('Final price depends on total order weight, shown at checkout.') + '</span>' : '') +
        '</div>' +
        '<strong class="shipest__rate-price mono">' + priceLine(r, cn) + '</strong>' +
      '</div>';
    });
    if (rates.some(function (r) { return usesConverted(r, cn); })) {
      html += '<p class="shipest__fxnote">* ' + GT('Local currency values are indicative. Small differences may appear at checkout due to exchange-rate movement, rounding, or bank fees.') + '</p>';
    }
    res.innerHTML = html;
    warning.hidden = (cn === 'United States');
  }

  country.addEventListener('change', function () {
    updateZipState();
    if (country.value && !NEEDS_ZIP[country.value]) calc();
    else { res.hidden = true; res.innerHTML = ''; warning.hidden = true; }
  });
  if (go) go.addEventListener('click', calc);
  if (zip) zip.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); calc(); }
  });
  updateZipState();
})();

/* ==========================================================================
   Dispatch countdown - rebuilt from the legacy shipping timer.
   Portugal working days, full PT holiday calendar (fixed + movable dates),
   Europe/Lisbon timezone, configurable cutoff hour. Live per-minute update.
   ========================================================================== */
(function () {
  'use strict';
  var els = document.querySelectorAll('[data-dispatch]');
  if (!els.length) return;

  var HOLIDAYS_PT = [
    /* fixed national (MM-DD) */
    '01-01', '04-25', '05-01', '06-10', '08-15', '10-05', '11-01', '12-01', '12-08', '12-25',
    /* movable + Castelo Branco local (YYYY-MM-DD) */
    '2025-03-04', '2025-04-18', '2025-04-20', '2025-05-06', '2025-06-19',
    '2026-02-17', '2026-04-03', '2026-04-05', '2026-04-21', '2026-06-04',
    '2027-02-09', '2027-03-26', '2027-03-28', '2027-04-13', '2027-05-27'
  ];
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function lisbonNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Lisbon' }));
  }
  function pad(n) { return String(n).padStart(2, '0'); }
  function isHoliday(d) {
    var md = pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    var ymd = d.getFullYear() + '-' + md;
    return HOLIDAYS_PT.indexOf(md) !== -1 || HOLIDAYS_PT.indexOf(ymd) !== -1;
  }
  function isWorkingDay(d) {
    var wd = d.getDay();
    return wd !== 0 && wd !== 6 && !isHoliday(d);
  }

  function update() {
    var now = lisbonNow();
    els.forEach(function (el) {
      var cutoff = Number(el.getAttribute('data-cutoff') || 10);
      var text = el.querySelector('[data-dispatch-text]');
      if (!text) return;
      var target = new Date(now);
      var today = isWorkingDay(now) && now.getHours() < cutoff;
      if (today) {
        target.setHours(cutoff, 0, 0, 0);
        var diff = target - now;
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        text.innerHTML = GT('Order within') + ' <strong class="mono">' +
          (h > 0 ? h + 'h ' : '') + m + 'm</strong> ' + GT('and it ships') + ' <strong>' + GT('today') + '</strong>.';
      } else {
        target.setHours(cutoff, 0, 0, 0);
        target.setDate(target.getDate() + 1);
        while (!isWorkingDay(target)) target.setDate(target.getDate() + 1);
        var dayDiff = Math.round((new Date(target.getFullYear(), target.getMonth(), target.getDate()) -
                                  new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000);
        var label = dayDiff === 1 ? GT('tomorrow') : GT('on {d}').replace('{d}', GT(DAYS[target.getDay()]));
        text.innerHTML = GT('Order now, ships') + ' <strong>' + label + '</strong> ' + GT('(next working day).');
      }
      el.hidden = false;
    });
  }
  update();
  setInterval(update, 30000);
})();


/* ==========================================================================
   Product gallery zoom-on-hover - zoom origin follows the cursor.
   ========================================================================== */
(function () {
  'use strict';
  var stage = document.querySelector('.product__stage');
  if (!stage) return;
  stage.addEventListener('mousemove', function (e) {
    var img = stage.querySelector('img');
    if (!img) return;
    var r = stage.getBoundingClientRect();
    var x = ((e.clientX - r.left) / r.width) * 100;
    var y = ((e.clientY - r.top) / r.height) * 100;
    img.style.transformOrigin = x + '% ' + y + '%';
  });
  stage.addEventListener('mouseleave', function () {
    var img = stage.querySelector('img');
    if (img) img.style.transformOrigin = 'center center';
  });
})();

/* ==========================================================================
   Description read-more: implementation lives in finder.js (initDescToggle).
   The duplicate that used to live here fought finder.js over btn.hidden and
   used a different label + threshold - removed in v4.42.
   ========================================================================== */


/* ==========================================================================
   Sticky add-to-cart bar (mobile) - appears when the buy box scrolls away
   ========================================================================== */
(function () {
  'use strict';
  var bar = document.querySelector('[data-sticky-atc]');
  var realBtn = document.querySelector('[data-add-to-cart]');
  if (!bar || !realBtn || !('IntersectionObserver' in window)) return;
  var btn = bar.querySelector('[data-sticky-atc-btn]');
  var io = new IntersectionObserver(function (entries) {
    var e = entries[0];
    bar.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
  }, { threshold: 0 });
  io.observe(realBtn);
  if (btn) btn.addEventListener('click', function () {
    realBtn.click(); /* reuse the real form submit + ajax path */
  });
})();

/* ==========================================================================
   Photo attach for contact forms (v4.43) - Shopify's contact endpoint is
   text-only, so photos are uploaded to the WSP Uploads Apps Script first
   (Drive storage, share links back), and the links travel inside the
   hidden contact[photo_links] text field.
   ========================================================================== */
(function () {
  'use strict';
  var MAX_PHOTOS = 10;
  var MAX_EDGE = 1600;       /* px, longest side after resize */
  var MAX_RAW = 8 * 1024 * 1024; /* undecodable originals (e.g. HEIC) up to 8MB */

  function initPhotoAttach(root) {
    if (!root || root.getAttribute('data-photo-ready')) return;
    var endpoint = root.getAttribute('data-endpoint');
    if (!endpoint) return;
    root.setAttribute('data-photo-ready', '1');
    var input = root.querySelector('[data-photo-input]');
    var pick = root.querySelector('[data-photo-pick]');
    var list = root.querySelector('[data-photo-list]');
    var status = root.querySelector('[data-photo-status]');
    var links = root.querySelector('[data-photo-links]');
    var form = root.closest('form');
    var items = []; /* { url, el, pending } */
    var idleMsg = status ? status.textContent : '';

    function setStatus(msg, cls) {
      if (!status) return;
      status.textContent = msg;
      status.className = 'photoattach__status mono' + (cls ? ' photoattach__status--' + cls : '');
    }
    function syncLinks() {
      links.value = items.filter(function (i) { return i.url; })
                         .map(function (i) { return i.url; }).join('\n');
      if (pick) pick.hidden = items.length >= MAX_PHOTOS;
    }
    function pendingCount() {
      return items.filter(function (i) { return i.pending; }).length;
    }

    function addThumb(dataUrl) {
      var el = document.createElement('div');
      el.className = 'photoattach__item is-uploading';
      el.innerHTML = '<img alt="Attached photo preview">' +
        '<button type="button" class="photoattach__remove" aria-label="Remove photo">&times;</button>' +
        '<span class="photoattach__spin" aria-hidden="true"></span>';
      el.querySelector('img').src = dataUrl;
      list.appendChild(el);
      return el;
    }

    function resizeToJpeg(file) {
      return new Promise(function (resolve, reject) {
        var img = new Image();
        var obj = URL.createObjectURL(file);
        img.onload = function () {
          try {
            var w = img.naturalWidth, h = img.naturalHeight;
            var scale = Math.min(1, MAX_EDGE / Math.max(w, h));
            var c = document.createElement('canvas');
            c.width = Math.round(w * scale); c.height = Math.round(h * scale);
            c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
            URL.revokeObjectURL(obj);
            resolve(c.toDataURL('image/jpeg', 0.82));
          } catch (e) { URL.revokeObjectURL(obj); reject(e); }
        };
        img.onerror = function () { URL.revokeObjectURL(obj); reject(new Error('decode')); };
        img.src = obj;
      });
    }
    function rawDataUrl(file) {
      return new Promise(function (resolve, reject) {
        if (file.size > MAX_RAW) return reject(new Error('too-big'));
        var r = new FileReader();
        r.onload = function () { resolve(String(r.result)); };
        r.onerror = function () { reject(new Error('read')); };
        r.readAsDataURL(file);
      });
    }

    function upload(item, dataUrl, filename) {
      var payload = {
        action: 'upload',
        name: filename,
        data: dataUrl.split(',')[1],
        type: (dataUrl.match(/^data:([^;]+);/) || [])[1] || 'image/jpeg'
      };
      /* text/plain body keeps this a CORS "simple request" - the same
         pattern the compatibility backend uses */
      return fetch(endpoint, { method: 'POST', body: JSON.stringify(payload) })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (data) {
          if (!data || !data.ok || !data.url) throw new Error(data && data.error || 'upload failed');
          item.url = data.url;
          item.pending = false;
          item.el.classList.remove('is-uploading');
          syncLinks();
          if (!pendingCount()) setStatus(items.length !== 1 ? GT('Photos attached. They will be included with your message.') : GT('Photo attached. It will be included with your message.'), 'ok');
        });
    }

    function handleFiles(files) {
      Array.prototype.slice.call(files).forEach(function (file) {
        if (items.length >= MAX_PHOTOS) return;
        if (!/^image\//.test(file.type) && !/\.(heic|heif)$/i.test(file.name)) {
          setStatus(GT('Only image files can be attached.'), 'err'); return;
        }
        var item = { url: '', el: null, pending: true };
        items.push(item);
        setStatus(GT('Uploading photo…'));
        resizeToJpeg(file)
          .catch(function () { return rawDataUrl(file); })
          .then(function (dataUrl) {
            item.el = addThumb(dataUrl);
            item.el.querySelector('.photoattach__remove').addEventListener('click', function () {
              items.splice(items.indexOf(item), 1);
              item.el.remove();
              syncLinks();
              setStatus(items.length ? status.textContent : idleMsg);
            });
            return upload(item, dataUrl, file.name || 'photo.jpg');
          })
          .catch(function (e) {
            items.splice(items.indexOf(item), 1);
            if (item.el) item.el.remove();
            syncLinks();
            setStatus(e && e.message === 'too-big'
              ? GT('That photo is too large. Please try one under 8MB.')
              : GT('That photo could not be uploaded. You can still send the message and email photos afterwards.'), 'err');
          });
      });
      input.value = '';
    }

    if (pick) pick.addEventListener('click', function () { input.click(); });
    input.addEventListener('change', function () { handleFiles(input.files); });

    if (form) form.addEventListener('submit', function (e) {
      if (pendingCount()) {
        e.preventDefault();
        setStatus(GT('One moment, your photo is still uploading…'));
      }
    });
    syncLinks();
  }

  document.querySelectorAll('[data-photo-attach]').forEach(initPhotoAttach);
  window.WSP = window.WSP || {};
  window.WSP.initPhotoAttach = function (node) {
    if (!node) return;
    if (node.matches && node.matches('[data-photo-attach]')) initPhotoAttach(node);
    else if (node.querySelectorAll) node.querySelectorAll('[data-photo-attach]').forEach(initPhotoAttach);
  };
})();



/* Shopify-native /policies/* pages: move the plain-words summary to
   sit right under Shopify's own h1 (Liquid cannot reach inside
   content_for_layout, so this one-line relocation happens here). */
(function () {
  var summary = document.querySelector('[data-policy-summary]');
  var title = document.querySelector('.shopify-policy__title');
  if (summary && title) { title.insertAdjacentElement('afterend', summary); summary.hidden = false; }
  else if (summary) { summary.hidden = false; } /* still show it, just higher up */
})();


/* Technical-support page: arriving from the finder's "no record"
   state carries ?model=...&offer=identify - prefill the form and
   reveal the free-belt banner so the promise follows the visitor. */
(function () {
  if (!/technical-support/.test(location.pathname)) return;
  var sp;
  try { sp = new URLSearchParams(location.search); } catch (e) { return; }
  var model = (sp.get('model') || '').trim().slice(0, 80);
  if (model) {
    var inp = document.getElementById('tec-model');
    if (inp && !inp.value) inp.value = model;
  }
  if (sp.get('offer') === 'identify') {
    var b = document.querySelector('[data-offer-banner]');
    if (b) {
      var mm = b.querySelector('[data-offer-model]');
      if (mm && model) mm.textContent = model;
      b.hidden = false;
    }
  }
})();
;


/* Cart: collapse the discount field behind a link (audit 4.3) - keeps
   coupon-hunters from bouncing to Google; auto-opens if a code is saved */
(function () {
  var wrap = document.querySelector('[data-discount-wrap]');
  if (!wrap) return;
  var toggle = wrap.querySelector('[data-discount-toggle]');
  var body = wrap.querySelector('[data-discount-body]');
  if (!toggle || !body) return;
  function open() { body.hidden = false; toggle.setAttribute('aria-expanded', 'true'); toggle.hidden = true; }
  toggle.addEventListener('click', open);
  try { if (localStorage.getItem('wsp_discount_code')) open(); } catch (e) {}
})();
